import { ref, computed, nextTick } from 'vue'
import { defineStore } from 'pinia'
import { useLanguage } from '@/core/composables/useLanguage'
import { getMenuByPage } from '../helpers/getMenuByPage'
import { SAMUDKOY } from '../constants'
import { useCommonStore } from './common'
import { useOverviewStore } from './overview'

export const useSamudkoyStore = defineStore('simakatra.samudkoy', () => {
  const commonStore = useCommonStore()
  const overviewStore = useOverviewStore()
  const { currentLang } = useLanguage()

  /** States */
  const page = ref(1)
  const translate = ref(false)

  /** Getters */
  const menu = computed(() => getMenuByPage(page.value))
  const isActivated = computed(() => commonStore.mainContent == 'samudkoy')
  const hasPageNext = computed(() => page.value > 0 && page.value < SAMUDKOY.NUM_PAGES)
  const hasPagePrev = computed(() => page.value > 1 && page.value <= SAMUDKOY.NUM_PAGES)
  const hasTranslate = computed(() =>
    currentLang.value == 'en'
      ? SAMUDKOY.TRANSLATE_EN_PAGES.indexOf(page.value) > -1
      : SAMUDKOY.TRANSLATE_TH_PAGES.indexOf(page.value) > -1
  )

  /** Actions */
  function flipTo(target: number) {
    page.value = target >= 1 && target <= SAMUDKOY.NUM_PAGES ? target : page.value
    return page.value
  }

  function flipUp(loop = false) {
    page.value = page.value < SAMUDKOY.NUM_PAGES ? page.value + 1 : loop ? 1 : page.value
    return page.value
  }

  function flipDown(loop = false) {
    page.value = page.value > 1 ? page.value - 1 : loop ? SAMUDKOY.NUM_PAGES : page.value
    return page.value
  }

  function translateOn() {
    translate.value = true
  }

  function translateOff() {
    translate.value = false
  }

  function showOverviewContent() {
    translate.value = false
    overviewStore.page = page.value       
    commonStore.mainContent = 'overview'
    nextTick(()=>{
      overviewStore.slideToActivePage()  
    })   
  }

  return {
    page,
    translate,
    menu,
    isActivated,
    hasPageNext,
    hasPagePrev,
    hasTranslate,
    flipTo,
    flipUp,
    flipDown,
    translateOn,
    translateOff,
    showOverviewContent,
  }
})
